<script setup lang="ts">
withDefaults(
  defineProps<{
    sites: { uuid: string; name: string }[]
    to?: string
    link?: boolean
    overflowTheme?: "light" | "dark"
  }>(),
  { link: true },
)
</script>

<template>
  <LabelItemList
    :items="sites"
    :item-to="(site) => `/portfolio/${site.uuid}`"
    :to="to"
    :link="link"
    :overflow-theme="overflowTheme"
  >
    <template #name="{ item }">
      <slot name="name" :site="item">{{ item.name }}</slot>
    </template>
  </LabelItemList>
</template>
